module.exports = __webpack_public_path__ + "img/home-question.23dd5a62.png";